import * as React from "react"
import tw, { css } from "twin.macro"

const GrayBand = ({ content }) => {
  const { data } = content
  const { texto_sin_formato1: mainText } = data
  return (
    <div
      css={tw`w-100vw relative inset-x-1/2 -ml-50vw -mr-50vw overflow-x-hidden bg-gris1 text-white`}
    >
      <div css={tw`px-5 md:px-9`}>
        <div css={tw`max-w-screen-xl mx-auto px-0`}>
          <div css={[tw`max-w-screen-xl mx-auto`, twContainer]}>
            <div css={twImageUnionEuropea}>
              <div css={twImageUnionEuropeaImagen}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={124}
                  height={83}
                  fill="none"
                >
                  <path
                    fill="#00309A"
                    d="m123.873 82.988.115-82.816L.115 0 0 82.814l123.873.174Z"
                  />
                  <path
                    fill="#FFCD00"
                    d="m62.4 13.348-1.032-3.126-1.018 3.133h-3.309l2.644 1.877-.955 3.188 2.652-1.916 2.657 1.918-1.046-3.14 2.772-1.994-3.367.06h.002ZM76.18 17.016l-1.032-3.126-1.018 3.133H70.82l2.643 1.876-.954 3.189 2.652-1.916 2.657 1.917-1.046-3.14 2.772-1.994-3.367.06h.002ZM86.175 27.092l-1.032-3.126-1.018 3.133h-3.309l2.643 1.877-.954 3.188 2.652-1.916 2.657 1.916-1.046-3.14 2.772-1.994-3.367.06.002.002ZM89.883 40.79l-1.032-3.124-1.017 3.133h-3.31l2.644 1.876-.954 3.189 2.651-1.916 2.658 1.917-1.046-3.14 2.772-1.994-3.367.06.001-.001ZM86.239 54.598l-1.033-3.126-1.017 3.133h-3.31l2.644 1.876-.954 3.189 2.652-1.916 2.657 1.917-1.046-3.14 2.772-1.994-3.367.06h.002ZM76.185 64.651l-1.032-3.126-1.018 3.133h-3.309l2.644 1.876-.955 3.189 2.652-1.916 2.657 1.918-1.046-3.14 2.772-1.994-3.367.06h.002ZM62.552 68.331l-1.032-3.124-1.018 3.133h-3.308l2.643 1.876-.954 3.189 2.651-1.916 2.658 1.916-1.047-3.14 2.773-1.994-3.368.06h.002ZM48.845 64.66l-1.032-3.126-1.018 3.133h-3.308l2.643 1.876-.955 3.189 2.652-1.916 2.657 1.918-1.046-3.14L52.21 64.6l-3.367.06h.002ZM38.786 54.653l-1.032-3.125-1.017 3.134h-3.31l2.644 1.876-.954 3.189 2.652-1.916 2.657 1.916-1.047-3.14 2.773-1.995-3.367.06h.002ZM35.028 40.833l-1.032-3.125-1.018 3.133H29.67l2.643 1.877-.955 3.188 2.652-1.915 2.657 1.915-1.046-3.14 2.773-1.994-3.368.06h.002ZM38.634 27.115l-1.032-3.124-1.018 3.133h-3.308l2.643 1.877-.954 3.188 2.651-1.916 2.658 1.918-1.047-3.14L42 27.056l-3.367.06.001-.002ZM48.695 17.103l-1.032-3.126-1.018 3.133h-3.309l2.643 1.876-.954 3.189 2.652-1.916 2.657 1.917-1.046-3.14 2.772-1.994-3.367.06h.002Z"
                  />
                </svg>
              </div>
              <div css={twImageUnionEuropeaTexto}>
                <div css={twImageUnionEuropeaTextoHeader}>Unión europea</div>
                <div>
                  <span>Fondo Europeo de Desarrollo Regional</span>
                  <strong>Una manera de hacer Europa</strong>
                </div>
              </div>
            </div>
            <div css={twTextoPrincipal}>{mainText}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

const twContainer = css`
  padding-top: 30px;
  padding-bottom: 30px;
  @media (min-width: 768px) {
    display: flex;
    align-items: flex-start;
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

const twImageUnionEuropea = css`
  display: flex;
  @media (min-width: 768px) {
  }
`
const twImageUnionEuropeaImagen = css`
  padding-right: 16px;
  @media (min-width: 768px) {
    flex: calc(5 / 12);
  }
`
const twImageUnionEuropeaTexto = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-weight: 300;
  strong {
    display: block;
    font-weight: 700;
  }
  @media (min-width: 768px) {
    font-size: 11px;
  }
`
const twImageUnionEuropeaTextoHeader = css`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  @media (min-width: 768px) {
  }
`
const twTextoPrincipal = css`
font-size: 9px;
padding-top: 30px;
  @media (min-width: 768px) {
    font-size: 11px;
    flex: 1;
    padding-top: 0;
    padding-left: 10%;
  }
`

export default GrayBand
